import { reactive } from 'vue'
import type { Router } from 'vue-router'

const MAX = 50

const state = reactive({
  history: [] as string[],
})

function push(path: string) {
  if (state.history[state.history.length - 1] !== path) {
    state.history.push(path)
    if (state.history.length > MAX) state.history.shift()
  }
}

function goBack(router: Router, fallback = '/home') {
  state.history.pop()
  const prev = state.history[state.history.length - 1]
  if (prev) {
    router.push(prev)
  } else {
    router.push(fallback)
  }
}

export const navigationStore = { state, push, goBack }
